import { render, staticRenderFns } from "./ChairDeviceDetail.vue?vue&type=template&id=5be83dc9&scoped=true&"
import script from "./ChairDeviceDetail.vue?vue&type=script&lang=js&"
export * from "./ChairDeviceDetail.vue?vue&type=script&lang=js&"
import style0 from "./ChairDeviceDetail.vue?vue&type=style&index=0&id=5be83dc9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be83dc9",
  null
  
)

export default component.exports